import { Component, HostListener, Input, OnInit, OnDestroy } from '@angular/core';
import { AppDetailsService } from '../services/app-details.services';
import { ALL_GAMES_LIMIT, language } from '../shared/utility/config';
import { EmitterService } from '../services/emitter.service';
import { TranslateService } from '@ngx-translate/core';
import { Utility } from "../shared/utility/utility";
import { environment } from '../../environments/environment';
import { UserDetailsService } from '../services/user-details.service';
import * as _ from 'underscore';
import * as $ from 'jquery';
import { Router, NavigationEnd } from '@angular/router';
import { BannerService } from '../../app/services/banner.service';
import { AjaxService } from '../services/ajax.service';
import { takeUntil } from "rxjs/operators";
import { Subject, forkJoin } from "rxjs";
import { GameWindowService } from '../services/gameWindow.services';
import { EnvironmentService } from '../shared/services/environment.services';




@Component({
  selector: 'app-home-games-lang',
  templateUrl: './app-home-games-lang.component.html',
  styleUrls: ['./app-home-games-lang.component.scss']
})
export class AppHomeGamesLangComponent implements OnInit, OnDestroy {
  languageList;
  langCode: any;
  isCountryAllowed: number = 0;
  isUserLoggedIn: boolean;
  cookieClose: boolean;
  allGamesLimit;
  currentURL_slug;
  userDetail: any;
  viewLang: boolean;
  translates;
  countryCode;
  @Input()
  isLoggedIn: boolean = false;
  scrolledToTop: boolean = true;
  @Input() isGamesPage = false;
  @Input() promotion = false;
  @Input() promotions = false;

  destroy$: Subject<boolean> = new Subject<boolean>();
  isHomePage: any;
  mappedLanguageCodes;
  lobbyDetails: any;
  windowType: string;
  @Input() promotionMappedLanguageCodes;
  @Input() allPromotions = false;
  @Input() allPromotionMappedLanguageCodes;

  @HostListener('document:click', ['$event'])
  onClick(event) {
    if (event.target.classList.contains('overlay')) {
      this.viewLang = false;
    }
  }
  @Input() sortedGameData = [];

 
  constructor(
    private appDetails: AppDetailsService,
    private appDetailsService: AppDetailsService,
    private emitterService: EmitterService,
    private translate: TranslateService,
    private utils: Utility,
    private userDetailsService: UserDetailsService,
    private router: Router,
    private bannerService: BannerService,
    private ajaxService: AjaxService,
    private gameWindowService:GameWindowService,
    private environMentService:EnvironmentService
  ) {
    this.allGamesLimit = ALL_GAMES_LIMIT;
    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(lang => {
      this.langCode = lang;
    });

    this.emitterService.userCountry$.pipe(takeUntil(this.destroy$)).subscribe(country => {
      if (environment.trustlyCountries.indexOf(country) >= 0) {
        this.getCountry(country);
      } else {
        this.getCountry();
      }
    });
    this.getGameDetails(false);  
    this.isLoggedIn = this.utils.isUserLoggedIn();
  }

  ngOnInit() {
    this.appDetails.deleteGameLauncherParams();

    this.translates = this.translate;
    Promise.resolve(this.appDetailsService.getBlockedCountries())
      .then(
        res => {
          if (res && res["countryCode"] && res["countryCode"]) {
            this.countryCode = res["countryCode"];
          } else {
            this.countryCode = '-NA-';
          }
        },
        SystemError => { }
      );

    this.utils.getCookiePopup();
    if (localStorage.getItem('enableCookie')) {
      this.cookieClose = false;
    } else {
      this.cookieClose = true;
    }
    // this.mappedLanguageCodes = this.utils.mappedLanguageCodes();
    this.mappedLanguageCodes = this.environMentService.getActiveLanguageConfig();

    this.isHomePage = this.utils.getIsHomePage();
    this.getWindowType();
  }

  showSearchBar() {
    this.utils.showSearchBar();
  }

  @HostListener("window:scroll", ["$event"]) onWindowScroll() {
    this.onScrollGameTabs();
  }

  getWindowType(){
    const ww = document.body.clientWidth;
    if (ww <= 992) {
      this.windowType = "mobile";
    } else {
      this.windowType = "desktop";
    }
  }
  
  getCountry(country?: String) {
    if (country) {
      this.isCountryAllowed = 1;
      setTimeout(() => {
        this.emitterService.broadcastsetCountryCurrency(country);
      }, 100);
    } else {
      this.isCountryAllowed = 2;
    }
  }

  listClick(event, item) {
    event.preventDefault();
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    let lang = window.location.pathname.substring(1, 3);
    this.langCode = item;
    this.currentURL_slug = window.location.pathname.substring(3);
    if (item && item !== localStorage.getItem("langCode")) {
      this.langCode = item;
      this.bannerService.clearBanners();
      localStorage.setItem("langCode", this.langCode);
      this.emitterService.broadcastLangCode(this.langCode);
      this.router.navigate([this.langCode]);
      if (this.isUserLoggedIn) {
        Promise.resolve(this.userDetailsService.checkUserProfile())
          .then(completeUserStatus => {
                let userDetail = this.userDetailsService.getUserProfileDetails();
                this.utils.updateProfileLangCode(userDetail,completeUserStatus);
              })
      } else if (!this.isUserLoggedIn) {
        this.utils.reloadPage();
      }
    }
    this.viewLang = false;
  }

  onScrollGameTabs() {
    setTimeout(() => {
      const ww = document.body.clientWidth;
      const langDD: HTMLElement = document.querySelector('#homepage-languages')
      if (!this.utils.inViewport(langDD)) {
        if (this.viewLang) {
          this.viewLang = false;
        }
      }
    });
  }

  getGameDetails(isForce=false) {
    this.lobbyDetails = this.gameWindowService.lobbyDetails;

    const lobbyAndGameGroupFetchArray = [];
    if(!this.lobbyDetails || isForce){
      this.lobbyDetails = [];
      if(isForce){
        this.gameWindowService.lobbyDetails = undefined;
      }
      lobbyAndGameGroupFetchArray.push(this.gameWindowService.getLobbies(isForce))
    }
    
    if(lobbyAndGameGroupFetchArray.length > 0){
      forkJoin(lobbyAndGameGroupFetchArray).pipe(takeUntil(this.destroy$)).subscribe(lobbyGameGroupDetails =>{
        this.lobbyDetails = this.gameWindowService.lobbyDetails;
      })
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
